import SpriteSymbol from "../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-detail-getout",
  "use": "icon-detail-getout-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 90 90\" id=\"icon-detail-getout\"><defs><style>#icon-detail-getout .a{fill:rgba(255,255,255,0);}#icon-detail-getout .b,#icon-detail-getout .c{fill:none;stroke:currentColor;stroke-width:3px;}#icon-detail-getout .c{stroke-linejoin:round;}</style></defs><g transform=\"translate(-915 -370)\"><rect class=\"a\" width=\"90\" height=\"90\" transform=\"translate(915 370)\" /><path class=\"b\" d=\"M0,11.7,11.7,0,23.4,11.7\" transform=\"translate(990.922 419.602) rotate(90)\" /><line class=\"b\" x1=\"33.381\" transform=\"translate(956.5 431.3)\" /><path class=\"c\" d=\"M-8166.813,8466.936h-22.948V8426.3l30.275-19.59,31.409,19.59v13.643\" transform=\"translate(9119 -8027)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/detail-getout.svg
// module id = t+du
// module chunks = 62